import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
const Testimonial = (props) => {
  return (
    <div className="middle-section">
      <div className="container">
        <div className="cms-section">
          <div className="heading">
            <h2>Testimonials</h2>
          </div>
          <div className="whitebox">
            <div
              className="playerprofile-section"
              // style={{ maxHeight: "500px", overflowY: "auto" }}
            >
              <iframe
                id="socialjuice-wall-myclubtap-1848"
                title="Social Juice MyClubTap Wall"
                src="https://embed.socialjuice.io/wall/3417?s=myclubtap"
                allowtransparency="true"
                style={{ width: "100%", height: "575px", overflow: "hidden" }}
              ></iframe>
              <div className="button-group creategamebtn">
                {" "}
                <Link
                  to="https://testimonials.myclubtap.com/"
                  className="btn btn-primary"
                >
                  Leave us your feedback
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
